<template>
  <v-container fluid>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/parkaccessibility"> Filter Park Amenities & Accessible Features to Find a Park that Fits your Needs</router-link></h2>
            <div id="blurb">
              <p>
                  Everyone, everywhere, every day: access for all! That's the Arlington way. We are not only striving to meet <a target="_blank" href="https://www.access-board.gov/guidelines-and-standards/buildings-and-sites/about-the-ada-standards#:~:text=The%20ADA%20Standards%20establish%20design,state%20and%20local%20government%20facilities.">ADA Standards</a>, we want to do more. Use this form to filter the amenities and accessible features in our parks to find the ones that meet your needs. 
                  <br><br>
                  <strong>How to use: </strong><br>
                  <span>You can filter by any combination of amenities or accessible features by clicking on the plus icon to expand the options. Select as many as you would like by checking the box next to each option. The results will update automatically based on each amenity or accessible feature you select/deselect. </span><br><br>
                  <strong>Viewing Results: </strong><br>
                  <span>You can view your filter results in map or list form. Click on the Map or List text above the map. To view the details of a park, click on the blue location icon(s) on the map.  </span><br><br>
                  To request a correction, fill out this <a href="https://parks.arlingtonva.us/park-accessibility-correction-request/" target="_blank">form</a>.
              </p>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                </div>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <div class="filter-header" @click="amenityFilter = !amenityFilter" v-show="!isMobile" >
                            <span>Amenity
                                <svg v-show="amenityFilter" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!amenityFilter" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                        </div><br v-if="!amenityFilter"/>
                        <div class="filterList" v-show="amenityFilter || mobileMenu">
                            <!-- <div class="filter-item filter-category">Accessibilities</div> -->
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'parking'" type="checkbox" />
                                <span class="tooltip"> Parking</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'restroom'" type="checkbox" />
                                <span class="tooltip"> Restroom</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'seating'" type="checkbox" />
                                <span class="tooltip"> Seating</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'playarea'" type="checkbox" />
                                <span class="tooltip"> Play Area</span>
                            </div><br />
                        </div>
                          <div class="filter-header" @click="accessibilityFilter = !accessibilityFilter" v-show="!isMobile" >
                            <span>Accessible Features
                                <svg v-show="accessibilityFilter" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!accessibilityFilter" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                          </div><br />
                          <div class="filterList" v-show="accessibilityFilter || mobileMenu">
                            <div>
                              <label for="civicAssociation">Trails</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="trailsFilterSelected"
                                  :items="trailsFilter"
                                  outline
                                  :dense="true"
                                  height="20px"
                                  multiple
                                  hint="Select a surface"
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ trailsFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Fenced In</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="playAreaFilterSelected"
                                  :items="playAreaFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ playAreaFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Play Surface Material</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="playGroundCoverFilterSelected"
                                  :items="playGroundCoverFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ playGroundCoverFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Access to Sun Cover</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="sunCoverFilterSelected"
                                  :items="sunCoverFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ sunCoverFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Play/Park Access</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="parkAccessFilterSelected"
                                  :items="parkAccessFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ parkAccessFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Proximity to Roads</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="proximityFilterSelected"
                                  :items="proximityFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ proximityFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                            <div>
                              <label for="civicAssociation">Access to Pond/Stream</label>
                                <br />
                              <v-flex xs12 sm12 d-flex>
                                <v-select
                                  v-model="pondFilterSelected"
                                  :items="pondFilter"
                                  outline
                                  :dense="true"
                                  height="20"
                                  multiple
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0 && item.length > 14">{{ item.substring(0,14) + ".." }} &nbsp; </span>
                                    <span v-if="index === 0 && item.length <= 14">{{ item }} &nbsp; </span>
                                    <span
                                      v-if="index === 1"
                                      class="grey--text caption"
                                    >
                                      (+{{ pondFilterSelected.length - 1 }} others)
                                    </span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </div>
                        </div>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete ref="autocomplete" @place_changed="placeChanged"></gmap-autocomplete>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <h3 class="toggle-bar">
                    <a :class="showMap === true ? 'toggle-link' : 'toggle-link active'" @click="showMap = true">Map</a>
                    <a :class="showMap === false ? 'toggle-link' : 'toggle-link active'" @click="showMap = false" id="list-link">List</a>
                  </h3>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    >
                    <gmap-marker v-for="item in filteredItems"
                      :key="item.name"
                      :position="item"
                      :icon="icon"
                      :options="shapeOptions"
                      @click="(e) => shapeClick(item, e)">
                    </gmap-marker>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window">
                            <h3 class="info-window-header"><b v-html="selectedItem.Park"></b></h3>
                            <span>{{selectedItem['Address']}}</span>
                            <!-- <span v-if="selectedItem.parking || selectedItem.restroom || selectedItem.playarea">
                                <br>
                                <i v-if="selectedItem.parking" class="icon-free-parking"></i>
                                <i v-if="selectedItem.restroom" class="icon-restroom"></i>
                                <i v-if="selectedItem.seats" class="icon-free-parking"></i>
                                <i v-if="selectedItem.freshwater" class="icon-free-parking"></i>
                                <i v-if="selectedItem.playarea" class="icon-playground"></i>
                            </span> -->
                            <br><br>
                            <span v-if="selectedItem['Parking Access']"><b>Parking Access:</b> {{selectedItem['Parking Access']}}<br/></span>
                            <span v-if="selectedItem['Restroom Access']"><b>Restroom Access:</b> {{selectedItem['Restroom Access']}}<br/></span>
                            <span v-if="selectedItem['Park/Play Area Perimeter']"><b>Park/Play Area Perimeter:</b> {{selectedItem['Park/Play Area Perimeter']}}<br/></span>
                            <span v-if="selectedItem['Play/Park Access']"><b>Park/Play Access:</b> {{selectedItem['Play/Park Access']}}<br/></span>
                            <span v-if="selectedItem['accessible playground equip.']"><b>Accessible Playground Equipment:</b> {{selectedItem['accessible playground equip.']}}<br/></span>
                            <span v-if="selectedItem['Play/Surface Ground Cover']"><b>Play Surface Material:</b> {{selectedItem['Play/Surface Ground Cover']}}<br/></span>
                            <!-- <span v-if="selectedItem['ground cover (laymans)']"><b>Ground Cover (laymans):</b> {{selectedItem['ground cover (laymans)']}}<br/></span> -->
                            <span v-if="selectedItem['Access to Sun Cover']"><b>Access to Sun Cover:</b> {{selectedItem['Access to Sun Cover']}}<br/></span>
                            <span v-if="selectedItem['Proximity to Roads']"><b>Proximity to Roads:</b> {{selectedItem['Proximity to Roads']}}<br/></span>
                            <span v-if="selectedItem['seating']"><b>Seating:</b> {{selectedItem['seating']}}<br/></span>
                            <span v-if="selectedItem['Fresh Water on Site'] && selectedItem['Fresh Water on Site'] != 'n/a'"><b>Pond/Stream:</b> {{selectedItem['Fresh Water on Site']}}<br/></span>
                            <span v-if="selectedItem['Play Area on Site'] && selectedItem['Play Area on Site'] != 'N/A'"><b>Play Area on Site:</b> {{selectedItem['Play Area on Site']}}<br/></span>
                            <span v-if="selectedItem['trails'] && selectedItem['trails'] != 'N/A'"><b>Trails:</b> {{selectedItem['trails']}}<br/></span>
                            <a @click="openLink(selectedItem['URL'])">View Full Park Details</a>
                        </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="item in filteredItems" :key="item.Facility" class="project">
                    <div>
                      <div class="row">
                        <h3 class="h3-list"><b v-html="item.Park"></b></h3>
                      </div>
                        <p class="no-vertical-margin">
                            <span>{{item['Address']}}</span><br/>
                            <!-- <i v-if="item.parking" class="icon-free-parking"></i>
                            <i v-if="item.restroom" class="icon-restroom"></i>
                            <i v-if="item.seats" class="icon-free-parking"></i>
                            <i v-if="item.freshwater" class="icon-free-parking"></i>
                            <i v-if="item.playarea" class="icon-playground"></i> -->
                        </p><br/>
                        <p class="no-vertical-margin">
                        <span v-if="item['Parking Access']"><b>Parking Access:</b> {{item['Parking Access']}}<br/></span>
                        <span v-if="item['Park/Play Area Perimeter']"><b>Park/Play Area Perimeter:</b> {{item['Park/Play Area Perimeter']}}<br/></span>
                        <span v-if="item['Play/Park Access']"><b>Park/Play Access:</b> {{item['Play/Park Access']}}<br/></span>
                        <span v-if="item['Restroom Access']"><b>Restroom Access:</b> {{item['Restroom Access']}}<br/></span>
                        <span v-if="item['accessible playground equip.']"><b>Accessible Playground Equipment:</b> {{item['accessible playground equip.']}}<br/></span>
                        <span v-if="item['Play/Surface Ground Cover']"><b>Play Surface Material:</b> {{item['Play/Surface Ground Cover']}}<br/></span>
                        <!-- <span v-if="item['ground cover (laymans)']"><b>Ground Cover (laymans):</b> {{item['ground cover (laymans)']}}<br/></span> -->
                        <span v-if="item['Access to Sun Cover']"><b>Access to Sun Cover:</b> {{item['Access to Sun Cover']}}<br/></span>
                        <span v-if="item['Proximity to Roads']"><b>Proximity to Roads:</b> {{item['Proximity to Roads']}}<br/></span>
                        <span v-if="item['seating']"><b>Seating:</b> {{item['seating']}}<br/></span>
                        <span v-if="item['Fresh Water on Site'] && item['Fresh Water on Site'] != 'n/a'"><b>Pond/Stream:</b> {{item['Fresh Water on Site']}}<br/></span>
                        <span v-if="item['Play Area on Site'] && item['Play Area on Site'] != 'N/A'"><b>Play Area on Site:</b> {{item['Play Area on Site']}}<br/></span>
                        <span v-if="item['trails'] && item['trails'] != 'N/A'"><b>Trails:</b> {{item['trails']}}<br/></span>
                        <a @click="openLink(item['URL'])">View Full Park Details</a>
                        </p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </v-container>
</template>

<script>
import R from 'ramda';
import _ from 'lodash';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
})

export default {
  name: 'parkAccessibility',
  data () {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      amenityFilter: false,
      accessibilityFilter: false,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      trailsFilter: ['Gravel', 'Mixed', 'Natural', 'Paved'],
      trailsFilterSelected: [],
      playAreaFilter: ['Fenced in', 'Not Fenced in', 'Partially Fenced'],
      playAreaFilterSelected: [],
      groundCoverFilter: ['Asphalt', 'Astroturf', 'Concrete', 'Dirt', 'Grass', 'Mulch', 'Rubber Turf', 'Sand', 'Wood Chips'],
      groundCoverFilterSelected: [],
      playGroundCoverFilter: ['Asphalt', 'Concrete', 'Engineered Wood Fiber', 'Natural', 'Paved', 'Sand', 'Synthetic Playground Turf', 'Wood Chips'],
      playGroundCoverFilterSelected: [],
      sunCoverFilter: ['Covered pavillion', 'Gazebo', 'Indoor Facility', 'Limited/variable sun cover', 'No sun cover'],
      sunCoverFilterSelected: [],
      parkAccessFilter: ['No paved access to play area(s)', 'Paved sidewalk access', 'Ramp and stair access', 'Stairs', 'Stairs to trail', 'Stairs w/ bridge', 'Unpaved access'],
      parkAccessFilterSelected: [],
      proximityFilter: ['Adjacent to fields', 'Located with center/school', 'Isolated from roads', 'Next to main road/side road', 'Next to residences/buildings', 'Varies: trail crossings and some road crossings'],
      proximityFilterSelected: [],
      pondFilter: ['Access to Pond/Stream', 'No access to Pond/Stream'],
      pondFilterSelected: [],
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    }
  },
  computed: {
    ...mapGetters(['parkAccessibilities']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      return this.center;
    },
    filteredItems: function () {
      let _pa = this.parkAccessibilities;
      console.log(_pa)

      if (this.typeSelected.includes('parking')) {
        _pa = _pa.filter(f => f.parking)
      }
      if (this.typeSelected.includes('restroom')) {
        _pa = _pa.filter(f => f.restroom)
      }
      if (this.typeSelected.includes('seating')) {
        _pa = _pa.filter(f => f.seats)
      }
      if (this.typeSelected.includes('freshwater')) {
        _pa = _pa.filter(f => f.freshwater)
      }
      if (this.typeSelected.includes('playarea')) {
        _pa = _pa.filter(f => f.playarea)
      }

      _pa = this.checkFilter(_pa, this.trailsFilterSelected, 'trails')
      _pa = this.checkFilter(_pa, this.playAreaFilterSelected, 'Park/Play Area Perimeter')
      _pa = this.checkFilter(_pa, this.groundCoverFilterSelected, 'ground cover (laymans)')
      _pa = this.checkFilter(_pa, this.playGroundCoverFilterSelected, 'Play/Surface Ground Cover')
      _pa = this.checkFilter(_pa, this.sunCoverFilterSelected, 'Access to Sun Cover')
      _pa = this.checkFilter(_pa, this.proximityFilterSelected, 'Proximity to Roads')
      _pa = this.checkFilter(_pa, this.pondFilterSelected, 'Fresh Water on Site')

      if (this.parkAccessFilterSelected && this.parkAccessFilterSelected.length > 0) {
        let parkAccessFilterSelected = this.parkAccessFilterSelected.map(function (x) { return x.toLowerCase() })
        _pa = _.filter(_pa, f => {
          if (f['Play/Park Access']) {
            for (let i = 0; i < parkAccessFilterSelected.length; i++) {
              // edge conditions
              if (parkAccessFilterSelected[i] === 'stairs to trail') {
                return f['Play/Park Access'] === 'stairway to custis trail' || f['Play/Park Access'] === 'stairs to paved trail'
              }
              let included = _.includes(f['Play/Park Access'].toLowerCase(), parkAccessFilterSelected[i])
              if (included) {
                return true
              }
            }
          } else {
            return false
          }
        })
      }
      return _pa
    }
  },
  mounted: function () {
    this.loadParkAccessibilities();

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected () {
      this.infoWindowCheck();
    },
    projectTypesSelected () {
      this.infoWindowCheck();
    }
  },
  methods: {
    ...mapActions(['loadParkAccessibilities']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    checkFilter: function (items, filterSelected, itemProp) {
      let filtered = items;
      if (filterSelected && filterSelected.length > 0) {
        let _filterSelected = filterSelected.map(function (x) { return x.toLowerCase() })
        filtered = _.filter(items, f => {
          if (f[itemProp]) {
            for (let i = 0; i < _filterSelected.length; i++) {
              let included = _.includes(f[itemProp].toLowerCase(), _filterSelected[i])
              // edge case for same wording
              if (included && _filterSelected[i] === 'access to pond/stream') {
                if (f[itemProp].toLowerCase().indexOf('no') >= 0) {
                  return false
                } else {
                  return true
                }
              } else if (included) {
                return true
              }
            }
          } else {
            return false
          }
        })
      }
      return filtered;
    },
    clearAll () {
      this.typeSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.trailsFilterSelected = []
      this.playAreaFilterSelected = []
      this.groundCoverFilterSelected = []
      this.playGroundCoverFilterSelected = []
      this.sunCoverFilterSelected = []
      this.parkAccessFilterSelected = []
      this.proximityFilterSelected = []
      this.pondFilterSelected = []
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function (lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    },
    openLink (link) {
      window.open(link, '_blank');
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
  color: #e87c1a;
    }

    .active {
      color: #015cb9;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}

.selectdiv {
  position: relative;
}
select::-ms-expand {
     display: none;
}

.selectdiv:before {
  content: ' >';
  font: 14px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;

  top: 18px;
  padding: 0 0 2px;

  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.info-window span b {
  font-weight: 500;
}

// .v-text-field--outline>.v-input__control>.v-input__slot
// {
//   min-height: 2px !important;
//   height: 20px !important;
//   display: flex!important;
//   align-items: center!important
// }

// .v-text-field--box>.v-input__control>.v-input__slot, .v-text-field--full-width>.v-input__control>.v-input__slot, .v-text-field--outline>.v-input__control>.v-input__slot {
//   min-height: 2px !important;
//   height: 20px !important;
//   display: flex!important;
//   align-items: center!important
// }


</style>



// WEBPACK FOOTER //
// parksAccessibility.vue?3a025148